import { render, staticRenderFns } from "./AxContainer.vue?vue&type=template&id=21aa7236"
import script from "./AxContainer.vue?vue&type=script&lang=ts"
export * from "./AxContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports